/* IV Biotics — anchor the mobile menu drawer flush below the *visible* header.
   On mobile the announcement bar scrolls away (and re-settles when the drawer
   opens), so the visible header bottom moves through a transition. We keep the
   drawer glued to the header's bottom on every frame while it's open, rather
   than snapshotting a (possibly mid-transition) value once. */
(function () {
  function positionDrawer(drawer, header) {
    if (window.matchMedia('(min-width: 750px)').matches) {
      if (drawer.dataset.ivbTop != null) {
        drawer.style.removeProperty('top');
        drawer.style.removeProperty('height');
        delete drawer.dataset.ivbTop;
      }
      return;
    }
    var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    if (drawer.dataset.ivbTop === String(bottom)) return; // no change → skip
    drawer.style.setProperty('top', bottom + 'px', 'important');
    drawer.style.setProperty('height', window.innerHeight - bottom + 'px', 'important');
    drawer.dataset.ivbTop = String(bottom);
  }

  function watch(container) {
    var rafId = null;
    function loop() {
      var open = container.hasAttribute('open') || container.classList.contains('menu-open');
      var drawer = document.querySelector('.menu-drawer');
      var header = document.querySelector('.header');
      if (open && drawer && header) {
        positionDrawer(drawer, header);
        rafId = requestAnimationFrame(loop);
      } else {
        rafId = null;
      }
    }
    new MutationObserver(function () {
      var open = container.hasAttribute('open') || container.classList.contains('menu-open');
      if (open && rafId == null) loop();
    }).observe(container, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  function init(root) {
    (root || document).querySelectorAll('.menu-drawer-container').forEach(watch);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
